import { FileText, Package, CupSoda, Milk, ShoppingBag, Wine, Beer, Hammer, Wrench, Layers, Cog, Cable, Nut, Cpu, Recycle, MoreHorizontal, Check, Info } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useApp } from "@/context/AppContext";
import { fileUrl } from "@/lib/api";

export const SCRAP_ICONS = {
  Paper: FileText, Cardboard: Package, "Plastic bottles (PET)": CupSoda, "HDPE plastic": Milk, "LDPE plastic / bags": ShoppingBag,
  Glass: Wine, "Beverage cans": Beer, Iron: Hammer, Steel: Wrench, Aluminium: Layers, Brass: Cog, Copper: Cable,
  "Other metal": Nut, "E-waste": Cpu, "Mixed dry waste": Recycle, Other: MoreHorizontal,
};

const slug = (s) => s.toLowerCase().replace(/[^a-z]+/g, "-");

export const ScrapPicker = ({ form, set }) => {
  const { t, meta } = useApp();
  const types = meta?.scrap_types || Object.keys(SCRAP_ICONS);
  const price = Object.fromEntries((meta?.materials || []).map((m) => [m.name, m.price]));
  const img = Object.fromEntries((meta?.materials || []).filter((m) => m.image).map((m) => [m.name, m.image]));
  const toggle = (tp) =>
    set({ scrap_types: form.scrap_types.includes(tp) ? form.scrap_types.filter((x) => x !== tp) : [...form.scrap_types, tp] });
  return (
    <div className="space-y-4">
      <p className="flex items-start gap-2 rounded-2xl bg-[#2E9E6B]/10 p-3 text-sm text-[#0D3B2B]" data-testid="dry-waste-note">
        <Info className="mt-0.5 h-4 w-4 shrink-0 text-[#2E9E6B]" />{t("We collect dry waste only. Choose all that apply, or pick 'Other' and tell us the material.")}
      </p>
      <div className="grid grid-cols-2 gap-3">
        {types.map((tp) => {
          const Icon = SCRAP_ICONS[tp] || Recycle;
          const on = form.scrap_types.includes(tp);
          return (
            <button key={tp} type="button" onClick={() => toggle(tp)} data-testid={`scrap-${slug(tp)}`}
              className={`relative flex min-h-[64px] items-center gap-3 rounded-2xl border-2 px-3 py-3 text-left text-sm font-semibold transition-colors active:scale-[.97] ${on ? "border-[#2E9E6B] bg-[#2E9E6B]/10 text-[#0D3B2B]" : "border-[#D2E0D8] bg-white text-[#4A6358]"}`}>
              {img[tp] ? <img src={fileUrl(img[tp])} alt="" className="h-10 w-10 shrink-0 rounded-xl object-cover" data-testid={`scrap-img-${slug(tp)}`} />
                : <Icon className={`h-6 w-6 shrink-0 ${on ? "text-[#2E9E6B]" : "text-[#7B968B]"}`} />}
              <span className="leading-tight">{t(tp)}{price[tp] > 0 && <span className="block text-[11px] font-bold text-[#2E9E6B]" data-testid={`scrap-price-${slug(tp)}`}>₹{price[tp]}/kg</span>}</span>
              {on && <Check className="absolute right-2 top-2 h-4 w-4 text-[#2E9E6B]" />}
            </button>
          );
        })}
      </div>
      {form.scrap_types.includes("Other") && (
        <Input data-testid="scrap-other-input" className="h-12 rounded-xl" placeholder={t("Which material? e.g. old cooler body, PVC pipes, tin sheets")}
          value={form.other_text} onChange={(e) => set({ other_text: e.target.value })} />
      )}
      <div>
        <label className="mb-1 block text-sm font-semibold text-[#0D3B2B]">{t("Approximate weight in kg (optional)")}</label>
        <Input data-testid="est-weight-input" type="number" inputMode="decimal" min="0" className="h-12 rounded-xl"
          placeholder={t("e.g. 10")} value={form.est_weight ?? ""} onChange={(e) => set({ est_weight: e.target.value })} />
      </div>
    </div>
  );
};
